/**
 * GradeBook Admin share JS
 *
 * @since 4.0.8
 * @version 1.0.0
 */
import * as lpUtils from "./utils";

/**
 * Submit filter parameters to server
 */
export const submitFilter = ( form, callBack ) => {
	let lpTarget = document.querySelector( '.lp-target' );
	let dataSend = window.lpAJAXG.getDataSetCurrent( lpTarget );
	dataSend.args.paged = 1;

	dataSend.args = lpUtils.mergeDataWithDatForm( form, dataSend.args );

	window.lpAJAXG.setDataSetCurrent( lpTarget, dataSend );

	const lpTargetY =
		form.getBoundingClientRect().top + window.scrollY - 100;
	window.scrollTo( { top: lpTargetY } );

	window.lpAJAXG.fetchAJAX( dataSend, callBack );
};

/**
 * Event change start date will set min end date
 */
export const dateChoiceFilterHandler = ( e, target ) => {
	if ( target.closest( '.start_date' ) ) {
		const elEndDate = target.closest( 'form' ).querySelector( '.end_date' );
		const valueStartDate = target.value;

		if ( ! valueStartDate ) {
			elEndDate.value = '';
		} else if ( valueStartDate > elEndDate.value ) {
			elEndDate.value = valueStartDate;
		}

		elEndDate.setAttribute( 'min', valueStartDate );
	}
}
